import { createApp } from 'vue';
import { initTheme } from '@dashboard/ui-kit';
import App from './app.vue';
import { createAppRouter } from './router';
import { installDocumentTitle } from './document-title';
import './styles.css';

// Before the app mounts, so the first paint is already the chosen theme
// rather than a flash of the other one.
initTheme();

const router = createAppRouter();

// The tab's title, which `index.html` ships as a placeholder and nothing
// replaced (`D121`).
installDocumentTitle(router);

createApp(App).use(router).mount('#app');
